import React from 'react';

const PhotoPreview = ({ file, onConfirm, onRetake, onReuploadClick, source, isProcessing }) => {
  const fileUrl = URL.createObjectURL(file);

  return (
    <div className="flex flex-col items-center p-8 bg-white rounded-lg shadow-md">
      <h2 className="text-2xl font-bold text-gray-800 mb-6">Review Your Photo</h2>
      <div className="w-full max-w-lg mb-6 rounded-lg overflow-hidden shadow-lg border-4 border-black">
        {file.type.startsWith('video/') ? (
          <video src={fileUrl} controls autoPlay muted className="w-full h-auto" />
        ) : (
          <img src={fileUrl} alt="Preview" className="w-full h-auto object-contain" />
        )}
      </div>
      <div className="flex space-x-4">
        <button
          onClick={onConfirm}
          disabled={isProcessing}
          className={`px-8 py-3 rounded-full text-lg font-semibold transition-colors duration-200 ${isProcessing ? 'bg-gray-400 text-gray-700 cursor-not-allowed' : 'bg-black text-white hover:bg-gray-800'}`}
        >
          Confirm Photo
        </button>
        {source === 'camera' ? (
          <button
            onClick={onRetake}
            disabled={isProcessing}
            className={`px-8 py-3 rounded-full text-lg font-semibold transition-colors duration-200 ${isProcessing ? 'bg-gray-400 text-gray-700 cursor-not-allowed' : 'bg-gray-200 text-gray-800 hover:bg-gray-300'}`}
          >
            Retake Photo
          </button>
        ) : (
          <button
            onClick={onReuploadClick}
            disabled={isProcessing}
            className={`px-8 py-3 rounded-full text-lg font-semibold transition-colors duration-200 ${isProcessing ? 'bg-gray-400 text-gray-700 cursor-not-allowed' : 'bg-gray-200 text-gray-800 hover:bg-gray-300'}`}
          >
            Re-upload
          </button>
        )}
      </div>
    </div>
  );
};

export default PhotoPreview;